'use strict';

var filterViewMixin = require('../filters/utils/filter.view.mixin');
var HOURS_OF_DAY = 24;

var computeChangedRange = function(previousValue, currentValue) {
    return [
        Math.min(previousValue, currentValue),
        Math.max(previousValue, currentValue),
    ];
};

var renderViewTemplate = function(view) {
    view.$el.html(view.template(view.model.toJSON()));
};

var renderHistogram = function(view) {
    var eightyPercentilePrice = view.model.get('eightyPercentilePrice');
    var heights = Odigeo._.map(view.model.get('pricePerTimeIntervalCollection').toJSON(), function(interval) {
        return 0.9 * interval.price / eightyPercentilePrice;
    });
    var histogram = view.histogram = Odigeo.UIElements.histogram(view.$cachedSelectors.histogram, {
        unit: '%',
    });
    var $histogram = view.$cachedSelectors.histogram;
    histogram.height = $histogram.outerHeight();
    histogram.refresh(heights);
    updateHistogramWidth(view);
};

var addSelectorToCache = function(view, selectorName) {
    view.$cachedSelectors[selectorName] = view.$el.find(view.selectors[selectorName]);
};

var addHistogramBarsToCache = function(view) {
    view.$cachedSelectors.bars = view.$cachedSelectors.histogram.find('.bar');
};

var updateBars = function(view, range, enabled) {
    view.$cachedSelectors.bars.slice(range[0], range[1])
        .attr('class', enabled ? 'bar' : 'bar-disabled');
};

var updateHistogramWidth = function(view) {
    view.histogram.width = view.$cachedSelectors.histogram.outerWidth();
};

var renderMinSelectedChange = function(model, current) {
    var previous = model.previous('minSelectedHour');
    var range = computeChangedRange(previous, current);
    updateBars(this, range, current < previous);
};

var renderMaxSelectedChange = function(model, current) {
    var previous = model.previous('maxSelectedHour');
    var range = computeChangedRange(previous, current);
    if (range[1] === HOURS_OF_DAY - 1) {
        range[1]++;
    }
    updateBars(this, range, current >= previous);
};

var bindEvents = function() {
    this.listenTo(this.model, 'change:minSelectedHour', renderMinSelectedChange);
    this.listenTo(this.model, 'change:maxSelectedHour', renderMaxSelectedChange);
    $(window).on('resize', Odigeo._.bind(function() {
        updateHistogramWidth(this);
    }, this));
};

module.exports = Backbone.View.extend(Odigeo._.defaults({
    selectors: {
        histogram: '.time_budget_histogram',
        cheapestToolTip: '.cheapest_tooltip',
    },

    initialize: function(options) {
        this.$cachedSelectors = {};
        this.template = options.template;
        renderViewTemplate(this);
        addSelectorToCache(this, 'histogram');
        addSelectorToCache(this, 'cheapestToolTip');
        renderHistogram(this);
        addHistogramBarsToCache(this);
        bindEvents.call(this);
    },
}, filterViewMixin));
